<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Gif Outline" class="d-icon d-icon--gif-outline" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 2.5A1.5 1.5 0 0 1 2.5 1h7A1.5 1.5 0 0 1 11 2.5v7A1.5 1.5 0 0 1 9.5 11h-7A1.5 1.5 0 0 1 1 9.5v-7ZM2.5 2a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5h-7Zm0 4A1.5 1.5 0 0 1 4 4.5h.5a.5.5 0 1 1 0 1H4a.5.5 0 0 0-.5.5v.5A.5.5 0 0 0 4 7v-.316a.5.5 0 0 1 .25-.934h.25a.5.5 0 0 1 .5.5V7.5a.5.5 0 0 1-.5.5H4a1.5 1.5 0 0 1-1.5-1.5V6ZM6 4.5a.5.5 0 0 1 .5.5v2.5a.5.5 0 1 1-1 0V5a.5.5 0 0 1 .5-.5ZM7 5a.5.5 0 0 1 .5-.5H9a.5.5 0 1 1 0 1H8v.25h.5a.5.5 0 1 1 0 1H8v.75a.5.5 0 1 1-1 0V5Z" fill="currentColor"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconGifOutline',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: '500',
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(s),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
